/** Inline or line brackets the model wrote instead of calling tools. */
const FAKE_TOOL_BRACKET_GLOBAL =
  /\[(?:Calling\s+)?(?:createDocument[^\]]*|Creating[^\]]*|create\s+(?:raw|summary)[^\]]*|Raw\s+transcript[^\]]*|Summary\s+doc[^\]]*|raw\s+doc|summary\s+doc|creating)\]/gi

function looksLikeFakeToolInner(inner: string): boolean {
  return /create|document|tool|raw|summary|calling|creating|invocation/i.test(inner)
}

/** Pull fake `[createDocument…]` / `[Raw transcript doc]` placeholders out of stored assistant text. */
export function extractFakeToolBrackets(content: string): { labels: string[]; cleaned: string } {
  const labels: string[] = []

  let cleaned = content.replace(FAKE_TOOL_BRACKET_GLOBAL, (match) => {
    labels.push(match.slice(1, -1).trim())
    return ''
  })

  cleaned = cleaned.replace(/^\s*\[([^\]]+)\]\s*$/gm, (full, inner: string) => {
    if (!looksLikeFakeToolInner(inner)) return full
    labels.push(inner.trim())
    return ''
  })

  cleaned = cleaned
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .replace(/[ \t]{2,}/g, ' ')
    .trim()

  return { labels, cleaned }
}
